module.exports = __webpack_public_path__ + "img/newgen.b0c5a7f8.png";